export default "__VITE_ASSET__KslwvlBm$wDvsDwYBKZI1g__"